import * as React from 'react'

import { NativeLink, Text } from 'main/ui'

interface IProps {
  onRequestLogin: () => void
}

function ExistingUser(props: IProps) {
  const { onRequestLogin } = props

  return (
    <div css={{ textAlign: 'center' }}>
      <Text>Already have an account?&nbsp;</Text>
      <NativeLink onClick={() => onRequestLogin()}>Login</NativeLink>
    </div>
  )
}

export default React.memo(ExistingUser)
